// Route string constants — single source of truth for all path strings.
// Never hardcode route paths across the codebase — always import from here.
export const ROUTES = {
  // Public
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  verifyEmail: '/verify-email',
  socialCallback: '/auth/callback',

  // Signed in, no organization yet
  orgSetup: '/org-setup',

  // Protected — portal
  dashboard: '/dashboard',
  apiKeys: '/api-keys',
  analytics: '/analytics',
  billing: '/billing',
  webhooks: '/webhooks',
  webhookLogs: '/webhooks/logs',
  activity: '/activity',
  settings: '/settings',
  settingsOrganization: '/settings/organization',
  allowedHosts: '/allowed-hosts',
  mcpSessions: '/mcp-sessions',
  modelCards: '/model-cards',
  howItWorks: '/how-it-works',
  modelCardDetail: '/model-cards/:modelId',

  // Protected — admin only
  admin: '/admin',
  adminUsers: '/admin/users',
  adminApiKeys: '/admin/api-keys',
  adminApiUsage: '/admin/api-usage',
  adminDetections: '/admin/detections',
  adminAllowedHosts: '/admin/allowed-hosts',
  adminThresholds: '/admin/thresholds',
} as const;
